import { LitElement, html } from "lit";
import api from "../api/index.js";

class AutocompleteElement extends LitElement {
	static get properties() {
		return {
			name: {
				type: String,
				reflect: true,
			},
			url: {
				type: String,
				reflect: true,
			},
			include: {
				type: String,
				reflect: true,
			},
			exclude: {
				type: String,
				reflect: true,
			},
			select: {
				type: String,
				reflect: true,
			},
			display: {
				type: String,
				reflect: true,
			},
			value: {
				type: String,
				reflect: true,
				converter: {
					toAttribute(val) {
						const retVal = String(val);
						return retVal;
					},

					fromAttribute(val) {
						let retVal;
						try {
							retVal = JSON.parse(val);
						} catch {
							retVal = val;
						}
						return retVal;
					},
				},
			},
			rawValue: {
				type: Object,
				reflect: true,
				converter: {
					toAttribute(val) {
						const retVal = String(val);
						return retVal;
					},

					fromAttribute(val) {
						let retVal;
						try {
							retVal = JSON.parse(val);
						} catch {
							retVal = val;
						}
						return retVal;
					},
				},
			},
			items: {
				type: Array,
			},
		};
	}

	constructor() {
		super();
		this.select = null;
		this.display = null;
		this.value = {};
		this.items = [];
		this.include = [];
		this.exclude = [];
		this.rawValue = {};
		this.clear = this.clear.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.onBlur = this.onBlur.bind(this);
		this.onInput = this.onInput.bind(this);
		this.onKeyup = this.onKeyup.bind(this);
		this.onSelect = this.onSelect.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	render(_obj) {
		const show = this.rawValue
			? (this.display ? this.rawValue[this.display] : this.rawValue) || ""
			: "";
		return html`
    <style>
      :host {
        display: block;
        position: relative;
      }

      * {
        box-sizing: border-box;
      }

      input {
        width: 90%;
        font-family: 'Roboto', sans-serif;
        font-size: 12px;
        padding: 8px;
        border: 1px solid #ddd;
      }

      #options {
        visibility: hidden;
        position: absolute;
        z-index: 100;
        top: 100%;
        display: block;
        width: 100%;
        max-height: 160px;
        overflow-y: auto;
        border: 1px solid #ddd;
      }

      :host([open]) #options {
        visibility: visible;
      }
    </style>
    
    <input id="input" type="text"
      value="${show}"
      @focus="${this.onFocus}"
      @blur="${this.onBlur}"
      @keyup="${this.onKeyup}"
      @change="${this.onChange}"
      @input="${this.onInput}">
      <span @click="${this.clear}">X</span>
     <fm-options id="options">
    ${this.items.map(
			(item) => html`
      <fm-option
        value="${JSON.stringify(item)}"
        @select="${this.onSelect}">
        ${this.display ? item[this.display] : item}
      </fm-option>
    `,
		)}
    </fm-options>
    `;
	}

	firstRendered() {
		/* console.log(`fm-auto firstrendered ${this.name} `,this.rawValue); */
		this.options = this.shadowRoot.querySelector("fm-options");
	}

	set open(open) {
		if (open) {
			this.setAttribute("open", "");
		} else {
			this.removeAttribute("open");
		}
		this.setAttribute("aria-expanded", open);
	}

	get open() {
		return this.hasAttribute("open");
	}

	set value(value) {
		/*  console.log(`fm_auto set value ${this.name} `,value); */
		this.rawValue = value;
	}

	clear() {
		/* console.log(`fm_auto clear ${this.name} `); */
		if (this.select) {
			this.rawValue[this.select] = null;
		}
		if (this.display) {
			this.rawValue[this.display] = null;
		}
		this.shadowRoot.querySelector("#input").value = "";
	}

	get value() {
		return this.select ? this.rawValue[this.select] : this.rawValue;
	}

	_update(query) {
		/*  console.log(`fm-auto _update ${this.name} `,this.rawValue); */
		clearTimeout(this._timeout);
		if (!this.shadowRoot.querySelector("#input").value) {
			this.clear();
		}
		this._timeout = setTimeout(async () => {
			let url;

			if (this.url.includes("?")) {
				url = `${this.url}&query=${query}`;
			} else {
				url = `${this.url}?query=${query}`;
			}

			if (this.include.length > 0) {
				url += `&include=${this.include.join(",")}`;
			}

			if (this.exclude.length > 0) {
				url += `&exclude=${this.exclude.join(",")}`;
			}

			this.items = await api.get(url);

			if (this.items.length === 1) {
				this.value = this.items[0];
			}
			/*
      if (this.items.length === 0) {
        this.clear();
      }
      */
		}, 200);
	}

	onFocus() {
		this.open = true;
	}

	onBlur() {
		const show = this.rawValue
			? (this.display ? this.rawValue[this.display] : this.rawValue) || ""
			: "";
		this.shadowRoot.querySelector("#input").value = show;
		this.open = false;
	}

	onKeyup(event) {
		switch (event.key) {
			case "ArrowDown": {
				this.options.select(this.options.next());
				break;
			}
			case "ArrowUp": {
				this.options.select(this.options.previous());
				break;
			}
			case "Enter": {
				if (this.open) {
					event.stopPropagation();
					this.rawValue = this.options.value;
					this.dispatchEvent(new Event("select"));
				}
				this.open = false;
				break;
			}
			case "Escape": {
				this.open = false;
			}
		}
	}

	onInput(event) {
		this._update(event.target.value);
	}

	onSelect(event) {
		this.rawValue = event.target.value;

		const show =
			(this.display ? this.rawValue[this.display] : this.rawValue) || "";

		const i = this.shadowRoot.querySelector("#input");
		i.value = show;

		this.open = false;
		this.dispatchEvent(new Event("select"));
	}

	onChange(_event) {
		/* console.log(`fm-auto onchange ${this.name} `,event.target.value); */
	}
}

customElements.define("fm-autocomplete", AutocompleteElement);
